import { installNetRecorder } from '@/devtools/netRecorder/install';

declare global {
  // eslint-disable-next-line no-var
  var __DEV__: boolean;
}

if (typeof globalThis !== 'undefined') {
  globalThis.__DEV__ = import.meta.env.MODE === 'development';
}

// Dev-server only: wraps fetch before the first API request. Resolves to a no-op stub in builds.
installNetRecorder();
